
import { ReactNode, useRef, useEffect, useState } from "react";
import { Box, Divider, Grid, Paper, Typography, Slide, Link } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useInView } from 'motion/react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation, EffectFade } from 'swiper/modules';
import AboutBanner from '../../images/demo-pics/about_main.avif'
import AboutVibe1 from '../../images/demo-pics/about_1.avif'
import AboutVibe2 from '../../images/demo-pics/about_2.avif'
import TossingSalad from '../../images/demo-pics/tossing_salad.avif'
import Twinsies from '../../images/demo-pics/twinsies.avif'
import CheezusChrispts from '../../images/demo-pics/cheezus_chrispts.avif'
import PlasterTexture from '../../images/white_plaster.avif';
import StuccoTexture from '../../images/stucco.avif';
import TastingVic from '../../images/demo-pics/tasting_vic.avif'
import MondayMag from '../../images/demo-pics/monday_mag.webp'
import SaanichNews from '../../images/demo-pics/saanich_news.webp'
import ChekNews from '../../images/demo-pics/chek_news.webp'
import StyledButton from "../../components/reusable/StyledButton";
import { useNavigate } from "react-router";

const useStyles = makeStyles()((theme) => ({

  banner: {
    overflow: 'hidden',
    borderRadius: '0px',
    [theme.breakpoints.up('lg')]: {
      height: '50vh',
      position: 'relative',
    }
  },
  bannerImg: {
    width: '100%', 
    display: 'block', 
    [theme.breakpoints.up('lg')]: {
      position: 'absolute', 
      transform: 'translate(0%, -15%)'
    }
  },
  swiperPaper: {
    display: 'flex',
    flex: '1 1 auto',
    position: 'relative',
    maxHeight: 'calc(100vh - 100px)', 
    overflow: 'hidden', 
    borderRadius: '0px',
    justifyContent: 'center',
    // width: '100%',
    // height: '100%',
    '& img': {
      height: '60vh',
      // margin: '80px',
      transform: 'scale(1.2)'
    }
  },
  featureOverlayWrapper: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
    position: 'absolute',
    height: '100%',
    width: '100%',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    '&:hover': { 
      backgroundColor: 'rgba(255, 255, 255, 0.7)'
  
    }
  },
  featureOverlay: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '90%',
    height: '90%',
    marginBottom: '16px',
    // backgroundColor: 'blue',
  },
  featureTitleLink: {
    background: 'black',  
    color: 'white', 
    width: 'fit-content', 
    padding: '8px  16px 8px 16px', 
    cursor: 'pointer'
  },
  featureContentLink: {
    width: '65%',
    minHeight: '8.6rem',
    cursor: 'pointer',
    padding: '8px  16px 0px 16px',
    display: '-webkit-box',
    color: 'white',
    fontWeight: '600',
    WebkitLineClamp: 4,
    // lineHeight: '40px',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    backgroundColor: 'rgba(0,0,0,0.8)',
    transition: 'transform 0.3s ease, width 0.3s ease',
    '&:hover': { 
      width: '96%'

    }
  }
}))

export default function About() {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const isInView1 = useInView(ref1, { once: true, amount: 0 });
  const isInView2 = useInView(ref2, { once: true, amount: 0.4 });
  const isInView3 = useInView(ref3, { once: true, amount: 0.4 });
  const isInView4 = useInView(ref4, { once: true, amount: 0.4 });
  const isInView5 = useInView(ref5, { once: true, amount: 0.4 });
  const isInView6 = useInView(ref6, { once: true, amount: 0.4 });
 
  return (
    <>
      <Paper elevation={8} className={classes.banner}>
          <img src={AboutBanner} className={classes.bannerImg}/>
      </Paper>

      <Box 
        ref={ref1} 
        sx={{ 
          minHeight: { xs: '100vh', md: '50vh' }, // Matches the expected layout box size
          width: '100%',
          overflow: 'hidden' // Prevents the off-screen Slide from causing scrollbars
        }}
      >
        <Slide in={isInView1} direction="up" >
          <Grid container spacing={{xs: 2, md: 8}} sx={{padding: {xs: 3, md: 5}, backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${PlasterTexture})`, backgroundSize: '50%', backgroundPosition: 'center'}}>
            <Grid size={{xs: 10, md: 3}} sx={{margin: 'auto'}}>
              <Paper  elevation={8} sx={{borderRadius: '10px'}}>
                <img src={AboutVibe1} style={{maxWidth: '100%', maxHeight: '70vh', display: 'block', borderRadius: '10px'}}/>
              </Paper>
            </Grid>
            <Grid size={{xs: 12, md: 8}} sx={{marginTop: 'auto', marginBottom: 'auto'}}>
              <Typography variant="h2" sx={{textAlign: 'center'}}>
                Geero. Guy-ro. Jeero. Jyro.
              </Typography>
              <Divider variant="middle"/>
              <Typography variant="body2" sx={{textAlign: 'center'}}>
                <Typography variant="h2" sx={{color: 'primary.main'}}>However you say it - it's delicious.</Typography>
                Before Gyrosa existed, we had already spent more than fifteen years working side by side in the food industry. Over those years, we came to understand what makes restaurants truly work and where there was room to do things differently.
              </Typography>
            </Grid>
          </Grid>
        </Slide>
      </Box>

      <Box 
        ref={ref2} 
        sx={{ 
          minHeight: { xs: '100vh', md: '50vh' }, // Matches the expected layout box size
          width: '100%',
          overflow: 'hidden' // Prevents the off-screen Slide from causing scrollbars
        }}
      >
        <Slide in={isInView2} direction="up" >
          <Grid container spacing={{xs: 2, md: 8}} sx={{position: 'relative', padding: {xs: '36px 24px 36px 24px', md: 5}, background: `linear-gradient(rgba(127, 183, 251, 0.6), rgba(127, 183, 251, 0.6)), url(${StuccoTexture})`, backgroundSize: '20%', backgroundPosition: 'center', borderTop: '2px solid rgba(127, 183, 251, 0.8)', borderBottom: '2px solid rgba(127, 183, 251, 0.8)'}}>
            <Grid size={{xs: 12, md: 8}} sx={{marginTop: 'auto', marginBottom: 'auto'}}>
              <Typography variant="body2" sx={{textAlign: 'center'}}>
                We saw that fast-casual dining often prioritized speed and convenience, while traditional restaurants focused on craftsmanship and experience. Both had their strengths, but rarely did they exist together in one place.
              </Typography>
            </Grid>
            <Grid size={{xs: 10, md: 3}} sx={{margin: 'auto'}}>
              <Paper  elevation={8} sx={{borderRadius: '10px'}}>
                <img src={AboutVibe2} style={{maxWidth: '100%', maxHeight: '70vh', display: 'block', borderRadius: '10px'}}/>
              </Paper>
            </Grid>
            </Grid>
        </Slide>
      </Box>

      <Box 
        ref={ref3} 
        sx={{ 
          minHeight: { xs: '100vh', md: '50vh' }, // Matches the expected layout box size
          width: '100%',
          overflow: 'hidden' // Prevents the off-screen Slide from causing scrollbars
        }}
      >
        <Slide in={isInView3} direction="up" >
          <Grid container spacing={{xs: 2, md: 8}} sx={{padding: {xs: 3, md: 5}, backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${PlasterTexture})`, backgroundSize: '50%', backgroundPosition: 'center'}}>
            <Grid size={{xs: 10, md: 3}} sx={{margin: 'auto'}}>
              <Paper  elevation={8} sx={{borderRadius: '10px'}}>
                <img src={Twinsies} style={{maxWidth: '100%', maxHeight: '70vh', display: 'block', borderRadius: '10px'}}/>
              </Paper>
            </Grid>
            <Grid size={{xs: 12, md: 8}} sx={{marginTop: 'auto', marginBottom: 'auto'}}>
              <Typography variant="h2" sx={{textAlign: 'center'}}>
                So we started asking a simple question:
              </Typography>
              <Divider variant="middle"/>
              <Typography variant="body2" sx={{textAlign: 'center'}}>
                <Typography variant="h2" sx={{color: 'primary.main'}}>Why can't there be both?</Typography>
                Part of the answer came from Greek culture where food is never just something you eat. It's something you share.
                In Greek homes and tavernas, meals are about connection. Guests are welcomed warmly, tables are filled generously, and the room is often buzzing with conversation and energy.
              </Typography>
            </Grid>
          </Grid>
        </Slide>
      </Box>

      <Box 
        ref={ref4} 
        sx={{ 
          minHeight: { xs: '100vh', md: '50vh' }, // Matches the expected layout box size
          width: '100%',
          overflow: 'hidden' // Prevents the off-screen Slide from causing scrollbars
        }}
      >
        <Slide in={isInView4} direction="up" >
          <Grid container spacing={{xs: 2, md: 8}} sx={{position: 'relative', padding: {xs: '36px 24px 36px 24px', md: 5}, background: `linear-gradient(rgba(255, 212, 80, 0.6), rgba(255, 212, 80, 0.6)), url(${StuccoTexture})`, backgroundSize: '20%', backgroundPosition: 'center', borderTop: '2px solid rgba(255, 212, 80, 0.8)', borderBottom: '2px solid rgba(255, 212, 80, 0.8)'}}>
            <Grid size={{xs: 12, md: 8}} sx={{marginTop: 'auto', marginBottom: 'auto'}}>
              <Typography variant="body2" sx={{textAlign: 'center'}}>
                From the beginning, Gyrosa wasn't just meant to be a great restaurant.
                It was built to bring people together.
                A place where families, friends, and communities can gather, share a meal, and feel welcomed every time they walk through the door.
              </Typography>
            </Grid>
            <Grid size={{xs: 10, md: 3}} sx={{margin: 'auto'}}>
              <Paper  elevation={8} sx={{borderRadius: '10px'}}>
                <img src={CheezusChrispts} style={{maxWidth: '100%', maxHeight: '70vh', display: 'block', borderRadius: '10px'}}/>
              </Paper>
            </Grid>
          </Grid>
        </Slide>
      </Box>

      <Box 
        ref={ref5} 
        sx={{ 
          minHeight: { xs: '100vh', md: '50vh' }, // Matches the expected layout box size
          width: '100%',
          overflow: 'hidden' // Prevents the off-screen Slide from causing scrollbars
        }}
      >
        <Slide in={isInView5} direction="up" >
          <Grid container spacing={{xs: 2, md: 8}} sx={{padding: {xs: 3, md: 5}, backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${PlasterTexture})`, backgroundSize: '50%', backgroundPosition: 'center'}}>
            <Grid size={{xs: 10, md: 3}} sx={{margin: 'auto'}}>
              <Paper  elevation={8} sx={{borderRadius: '10px'}}>
                <img src={TossingSalad} style={{maxWidth: '100%', maxHeight: '70vh', display: 'block', borderRadius: '10px'}}/>
              </Paper>
            </Grid>
            <Grid size={{xs: 12, md: 8}} sx={{marginTop: 'auto', marginBottom: 'auto'}}>
              <Typography variant="h2" sx={{textAlign: 'center'}}>
                One lesson passed down from a handsome greek mentor still guides the way we approach food today:
              </Typography>
              <Divider variant="middle"/>
              <Typography variant="body2" sx={{textAlign: 'center'}}>
                <Typography variant="h2" sx={{color: 'primary.main'}}>“You eat with your eyes before your mouth.”</Typography>
                A simple philosophy that continues to shape the pride behind every plate that leaves our kitchen.
                We created Gyrosa to bring that spirit of Greek hospitality into the rhythm of modern dining. A place where you can enjoy fresh, healthy food made with real ingredients, served quickly enough to fit into everyday life all without losing the warmth, energy, and care that make a meal memorable.
              </Typography>
            </Grid>
          </Grid>
        </Slide>
      </Box>

      {/* Un-commend when we have better pictures available */}
      {/* <Box 
        ref={ref6} 
        sx={{ 
          minHeight: { xs: '40vh', md: '50vh' }, // Matches the expected layout box size
          width: '100%',
          overflow: 'hidden' // Prevents the off-screen Slide from causing scrollbars
        }}
      >
        <Slide in={isInView6} direction="up" >
          <Grid container spacing={{xs: 3}} sx={{padding: {xs: 0, md: 0}, margin: 0, background: `linear-gradient(rgba(127, 183, 251, 0.6), rgba(127, 183, 251, 0.6)), url(${StuccoTexture})`, backgroundSize: '20%', backgroundPosition: 'center', borderTop: '2px solid rgba(127, 183, 251, 0.8)', borderBottom: '2px solid rgba(127, 183, 251, 0.8)'}} >
            <Grid size={{xs: 12}}>
              <Typography variant="h1" sx={{color: 'white', textAlign: 'center', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)', textTransform: 'uppercase'}}>What They're Saying about us</Typography>
            </Grid>
            <Grid size={{xs: 12, md: 6}} sx={{display: 'flex', alignItems: 'center', margin: 'auto'}} >
              <Swiper
                grid={{
                  rows: 1
                }}
                style={{
                  width: '100%',
                  paddingBottom: '30px',
                  maxHeight: 'calc(100vh - 100px)',
                }}
                grabCursor={true}
                fadeEffect={{
                  crossFade: true
                }}
                // navigation={true}
                slidesPerView={1}
                pagination={{
                  dynamicBullets: true,
                  dynamicMainBullets: 5
                }}
                loop={true}
                // autoplay={{delay: 5000}}
                modules={[Autoplay, Pagination, Navigation, EffectFade]}
              >
                <SwiperSlide >
                  <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={TastingVic} />
                    <Box className={classes.featureOverlayWrapper}>
                      <Box className={classes.featureOverlay}>
                        <Link 
                          variant='h2' 
                          underline='none'
                          href='https://www.tastingvictoria.com/p/new-greek-restaurant-victoria-gyrosa'
                          target='_blank'
                          className={classes.featureTitleLink}
                          >
                          TASTING VICTORIA
                        </Link>
                        <Link
                          variant='body2'
                          underline='hover'
                          href='https://www.tastingvictoria.com/p/new-greek-restaurant-victoria-gyrosa'
                          target='_blank'
                          className={classes.featureContentLink}
                        >
                          "Delicacies like gyros with thinly sliced meats, shrimp skewers and punchy salads are made by chefs who have long been dedicated to perfecting their craft."
                        </Link>
                      </Box>
                    </Box>
                    <div className="swiper-lazy-preloader"></div>
                  </Paper>
                </SwiperSlide>
                <SwiperSlide >
                  <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={ChekNews}/>
                    <Box className={classes.featureOverlayWrapper}>
                      <Box className={classes.featureOverlay}>
                        <Link 
                          variant='h2' 
                          underline='none'
                          href='https://www.tastingvictoria.com/p/new-greek-restaurant-victoria-gyrosa'
                          target='_blank'
                          className={classes.featureTitleLink}
                          >
                          CHEK NEWS
                        </Link>
                        <Link
                          variant='body2'
                          underline='hover'
                          href='https://www.tastingvictoria.com/p/new-greek-restaurant-victoria-gyrosa'
                          target='_blank'
                          className={classes.featureContentLink}
                        >
                          "... But as much as the owners take pride in their food they also take pride in great service and looking after their staff."
                        </Link>
                      </Box>
                    </Box>
                    <div className="swiper-lazy-preloader"></div>
                  </Paper>
                </SwiperSlide>
                <SwiperSlide >
                  <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={SaanichNews}/>
                    <Box className={classes.featureOverlayWrapper}>
                      <Box className={classes.featureOverlay}>
                        <Link 
                          variant='h2' 
                          underline='none'
                          href='https://www.tastingvictoria.com/p/new-greek-restaurant-victoria-gyrosa'
                          target='_blank'
                          className={classes.featureTitleLink}
                          >
                          SAANICH NEWS
                        </Link>
                        <Link
                          variant='body2'
                          underline='hover'
                          href='https://www.tastingvictoria.com/p/new-greek-restaurant-victoria-gyrosa'
                          target='_blank'
                          className={classes.featureContentLink}
                        >
                          "Tiginagas and his partners, Adrian Bears and Troy Nye share their commitment to quality and have a simple approach to what can be a very tough business."
                        </Link>
                      </Box>
                    </Box>
                    <div className="swiper-lazy-preloader"></div>
                  </Paper>
                </SwiperSlide>
                <SwiperSlide >
                  <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={MondayMag}/>
                    <Box className={classes.featureOverlayWrapper}>
                      <Box className={classes.featureOverlay}>
                        <Link 
                          variant='h2' 
                          underline='none'
                          href='https://www.tastingvictoria.com/p/new-greek-restaurant-victoria-gyrosa'
                          target='_blank'
                          className={classes.featureTitleLink}
                          >
                          MONDAY MAG
                        </Link>
                        <Link
                          variant='body2'
                          underline='hover'
                          href='https://www.tastingvictoria.com/p/new-greek-restaurant-victoria-gyrosa'
                          target='_blank'
                          className={classes.featureContentLink}
                        >
                          "... orders is a marvel to watch, in part because of the unmistakable camaraderie among them, and the joyful appreciation they show for every customer who walks through the door."
                        </Link>
                      </Box>
                    </Box>
                    <div className="swiper-lazy-preloader"></div>
                  </Paper>
                </SwiperSlide>
              </Swiper>
            </Grid>
            <Grid size={{xs: 12}}>
              <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingBottom: 8}}>
                <Typography variant='h2' sx={{pb: 4}}>See for yourself!</Typography>
                <StyledButton 
                  onClick={() => navigate('/order')}
                  fullWidth={true}
                  sx={{width: {xs: '80%', md: '50%'}}}
                  variant='contained'
                  size="large"
                >
                  Order Now
                </StyledButton>
              </Box>
            </Grid>
          </Grid>
        </Slide>
      </Box> */}

          {/* Card Carousel */}
          {/* {
            googleReviews?.length
              &&
            <Grid size={{xs: 12, md: 8}} sx={{height: '600px', display: 'flex'}} margin='auto'>
              <Swiper
                grid={{
                  rows: 1
                }}
                style={{
                  width: '100%',
                  paddingTop: '90px',
                  paddingBottom: '50px'
                }}
                effect={'coverflow'}
                grabCursor={true}
                fadeEffect={{
                  crossFade: true
                }}
                // navigation={true}
                slidesPerView={3}
                breakpoints={{
                  // when window width is >= 320px
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 30
                  },
                  // when window width is >= 640px
                  640: {
                    slidesPerView: 3,
                    spaceBetween: 40
                  }
                }}
                coverflowEffect={{
                  rotate: 50,
                  stretch: 0,
                  depth: 80,
                  modifier: 0.8,
                  slideShadows: true,
                }}
                pagination={{
                  dynamicBullets: true,
                  dynamicMainBullets: 5
                }}
                loop={true}
                autoplay={{delay: 5000}}
                modules={[Autoplay, EffectCoverflow, Pagination, Navigation, EffectFade]}
              >
                {
                  googleReviews?.map((e, i) => (
                    <SwiperSlide 
                      style={{
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        height: '400px'
                      }} 
                      key={i}
                    >
                      <Card
                        sx={{
                          height: '100%',
                          width: '100%',
                          borderRadius: 3,
                          display: 'block',
                          objectFit: 'cover'
                        }}
                      >
                        <CardContent>
                          <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                            <Avatar
                              slotProps={{ 
                                img: {
                                  loading: 'lazy',
                                }
                              }} 
                              src={e.authorAttribution.photoUri}
                              alt={e.authorAttribution.displayName}
                            />
                            <div>
                              <Typography variant="h3">
                                {e.authorAttribution.displayName}
                              </Typography>

                              <Rating value={e.rating} readOnly size="small" />
                            </div>
                          </Stack>

                          <Typography
                            variant="subtitle1"
                            className={classes.reviewText}
                          >
                            {e.text.text}
                          </Typography>
                          
                        </CardContent>
                        <div className="swiper-lazy-preloader"></div>
                      </Card>
                    </SwiperSlide>
                  ))
                }
              </Swiper>
            </Grid>
          } */}
    </>
  )
}
